import React from "react";
import { Component } from "react";
import axios from "axios";
// import {Input,Button} from 'mdbreact';

import domain from ".././../../../domain";
import { Row, Col, Card, CardBody } from "mdbreact";
const moment = require("moment");
let enumerateDaysBetweenDates = function (startDate, endDate) {
  var dates = [];

  var currDate = moment(startDate).startOf("day");
  var lastDate = moment(endDate).startOf("day");
  console.log(lastDate);
  dates.push(currDate.toDate());
  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    console.log(currDate.toDate());
    dates.push(currDate.clone().toDate());
  }
  console.log(dates);
  return dates;
};
export default class AddTimings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      course_id: "",
    };

    this.handleChange = this.handleChange.bind(this);
    //   this.handleTimeChange = this.handleTimeChange.bind(this);
  }
  handleChange = (e) => {
    //console.log(e)
    console.log(e.target.value);
  };
  // handleTimeChange(time) {
  //     console.log(time);     // <- prints "3600" if "01:00" is picked
  //     this.setState({ time });
  //   }
  componentDidMount() {
    // let timePickerHr = document.querySelector('.timepicker-wrapper').getElementsByTagName('hr')[0];
    // timePickerHr.style.border = "none";
    let courseId = this.props.match.params.id;
    console.log(courseId);
    axios
      .get(`${domain.DBServer}/fetch-course/${courseId}`)
      .then((result) => {
        console.log(result.data);
        this.setState({
          data: result.data,
          course_id: result.data[0].course_id,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  }

  render() {
    let options;
    //const { data } = this.state;
    console.log(this.state.data);
    let result;

    if (this.state.data) {
      let startd = moment(this.state.data[0].start_date).format("MM/DD/YYYY");
      let endd = moment(this.state.data[0].end_date).format("MM/DD/YYYY");
      result = enumerateDaysBetweenDates(startd, endd);
      if (result) {
        options = result.map((dates, key) => {
          return (
            <option key={key} value={moment(dates).format("MM/DD/YYYY")}>
              {moment(dates).format("MM/DD/YYYY")}
            </option>
          );
        });
      }
    }

    return (
      <Row className="justify-content-md-center">
        <Col md="6">
          <Card>
            <CardBody>
              <select
                onChange={this.handleChange.bind(this)}
                className="form-control"
                id="course"
                name="course"
              >
                {options}
              </select>
              {/* <TimePicker onChange={this.handleTimeChange} value={this.state.time}/> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}
